import * as queryString from 'query-string';
var OBJECT_PREFIX = "@json";
function encodeValue(value) {
    if (typeof value === 'object') {
        return "".concat(OBJECT_PREFIX).concat(JSON.stringify(value));
    }
    return value;
}
function decodeValue(value) {
    if (typeof value === 'string' && value.indexOf(OBJECT_PREFIX) === 0) {
        return JSON.parse(value.slice(OBJECT_PREFIX.length));
    }
    return value;
}
export function encode(obj) {
    return queryString.stringify(Object.keys(obj).reduce(function (acc, key) {
        acc[key] = encodeValue(obj[key]);
        return acc;
    }, {}));
}
export function decode(query) {
    if (query === void 0) { query = location.search; }
    var obj = queryString.parse(query);
    Object.keys(obj).forEach(function (key) {
        obj[key] = decodeValue(obj[key]);
    });
    return obj;
}
//# sourceMappingURL=urlParams.js.map